// カラースウォッチのツールチップ - 改善版
document.addEventListener('DOMContentLoaded', function() {
  // ツールチップ要素を1つだけ作成
  const tooltip = document.createElement('div');
  tooltip.className = 'swatch-tooltip';
  tooltip.style.position = 'fixed';
  tooltip.style.background = 'rgba(0, 0, 0, 0.9)';
  tooltip.style.color = '#ffffff';
  tooltip.style.padding = '8px 12px';
  tooltip.style.borderRadius = '6px';
  tooltip.style.fontSize = '12px';
  tooltip.style.fontWeight = '500';
  tooltip.style.whiteSpace = 'nowrap';
  tooltip.style.opacity = '0';
  tooltip.style.pointerEvents = 'none';
  tooltip.style.transition = 'opacity 0.2s ease';
  tooltip.style.zIndex = '99999';
  tooltip.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
  document.body.appendChild(tooltip);
  
  // マウス移動を追跡
  document.body.addEventListener('mousemove', function(e) {
    const label = e.target.closest('.swatch-input__label[title]');
    
    if (label) {
      const title = label.getAttribute('title');
      if (title) {
        tooltip.textContent = title;
        const rect = label.getBoundingClientRect();
        tooltip.style.left = (rect.left + rect.width / 2) + 'px';
        tooltip.style.top = (rect.bottom + 10) + 'px';
        tooltip.style.transform = 'translateX(-50%)';
        tooltip.style.opacity = '1';
      }
    } else {
      tooltip.style.opacity = '0';
    }
  });
  
  // スクロール時は非表示
  document.addEventListener('scroll', function() {
    tooltip.style.opacity = '0';
  }, true);
});
